import { $public } from '../http'

export default class ServiceService {
  static async getServiceById(data) {
    const { hash = 100, ...body } = data
    return $public.post(
      `/digest/guestListPaymentServicesSelected/${hash}`,
      body,
    )
  }
}
